export const press = {
  email: 'press@angel.com',
  location: 'Provo, UT',
  number: '+13235382130',
  phone: '(323) 538-2130',
  requestAnInterviewFormUrl: 'https://forms.gle/hKw5P1y1QuVPsKZh8',
}
